// extracted by mini-css-extract-plugin
module.exports = {"switch":"ToggleSwitch_switch__3dzVU","slider":"ToggleSwitch_slider__2i2eM","round":"ToggleSwitch_round__jCT-9","active":"ToggleSwitch_active__3AcJ_"};